import React, { useContext, useCallback } from 'react';
import PropTypes from 'prop-types';
import { I18nContext } from '@bingads-webui-react/i18n-context';
import { useDefaultStyles } from '@bingads-webui-react/with-default-styles';
import { GridTargetsBase } from '@bingads-webui-campaign/hotel-common-targets';
import { ScopeLevel } from '@bingads-webui-campaign-react/constants';
import { getGridStyles } from './style';
import image from './multimedia-ad.svg';
import { RANGE } from './util';

export const MultimediaAdBidAdjustment = ({ onDataChange, data, level }) => {
  const i18n = useContext(I18nContext);
  const classes = useDefaultStyles(getGridStyles);
  const { multimediaAds } = data;
  const nameColumn = (
    <div>
      <img src={image} alt={i18n.getString(_TL_('Multimedia ads icon'))} className={classes.image} />
      <span className={classes.name}>{i18n.getString(_TL_('Multimedia ads Bids'))}</span>
    </div>
  );
  const currentLevelSettings = [{
    ...multimediaAds.currentLevelData,
    name: nameColumn,
  }];
  const parentLevelSettings = level === ScopeLevel.AdGroup ? [{
    ...multimediaAds.parentLevelData,
    name: nameColumn,
  }] : undefined;
  const columns = [{
    key: 'meultimedia', name: i18n.getString(_TL_('Multimedia ads')), fieldName: 'name', minWidth: 100, maxWidth: 333, type: 'plainString', headerClassName: 'target-custom-header',
  }];

  const onChange = useCallback((newData) => {
    onDataChange({
      multimediaAds: {
        currentLevelData: newData.currentLevelSettings[0],
        parentLevelData: level === ScopeLevel.AdGroup ? newData.parentLevelSettings[0] : undefined,
        useParentLevel: newData.useParentLevel,
      },
    });
  }, [level, onDataChange]);

  return (
    <div className={classes.root}>
      <GridTargetsBase
        data={{
          currentLevelSettings,
          parentLevelSettings,
          useParentLevel: multimediaAds.useParentLevel,
        }}
        setData={onChange}
        basicConfig={{
          columns,
          minBid: RANGE.min,
          maxBid: RANGE.max,
          disableDecrease: true,
        }}
      />
    </div>
  );
};

MultimediaAdBidAdjustment.propTypes = {
  onDataChange: PropTypes.func.isRequired,
  data: PropTypes.shape({
    multimediaAds: PropTypes.shape({
      currentLevelData: PropTypes.shape({
        bidAdjustmentDropdown: PropTypes.string,
        bidAdjustmentInput: PropTypes.number,
      }),
      parentLevelData: PropTypes.shape({
        bidAdjustmentDropdown: PropTypes.string,
        bidAdjustmentInput: PropTypes.number,
      }),
      useParentLevel: PropTypes.bool,
    }),
  }).isRequired,
  level: PropTypes.string.isRequired,
};
